import { Nullable } from "@/general/custom-types/CustomTypes";

export class LoginFormModel {
  username: string;
  password: string;

  constructor(username: string, password: string) {
    this.username = username;
    this.password = password;
  }
}
